import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useContext, useState } from "react";
import { MainAppBar } from "./bar";
import { DashboardDrawer } from "./drawer";
import { Footer } from "../../components/footer";
import styles from "./app.module.scss";
import { Breadcrumb } from "../../components/breadcrumb";
import { BreadcrumbContext } from "../../contexts/breadcrumb";
import { appTheme } from "./theme";
import { IconButton } from "@mui/material";
import FullscreenRoundedIcon from '@mui/icons-material/FullscreenRounded';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

export const AppLayout = ({
  children,
  collapsed,
  isFota,
  isGridDetails,
  isCardsView,
  handleClose,
}) => {
  const [open, setOpen] = useState(false);
  const [closeAppBarAndDrawer, setCloseAppBarAndDrawer] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleCloseAppBarAndDrawer = (event) => {
    if (closeAppBarAndDrawer === false) {
      handleClose(true);
      setCloseAppBarAndDrawer(true);
    } else {
      handleClose(false);
      setCloseAppBarAndDrawer(false);
    }
  };


  return (
    <ThemeProvider theme={appTheme}>
      <div>
        <Box component="main"
          sx={{
            backgroundColor: isCardsView
              ? "rgb(23, 23, 23)"
              : (theme) =>
                theme.palette.mode === "light"
                  ? "rgba(239, 239, 239, 0.3)"
                  : theme.palette.grey[300],
            flexGrow: 1,
            height: "100vh",
            width: "100%",
            overflow: "auto",
            display: "flex"
          }}>
          <CssBaseline />
          {!closeAppBarAndDrawer ? (
            <>
              <MainAppBar open={open} toggleDrawer={toggleDrawer} />
              <DashboardDrawer open={open} toggleDrawer={toggleDrawer} />
            </>
          ) : (
            <></>
          )}
          <Container
            maxWidth="100%"
            sx={{ mt: isCardsView && closeAppBarAndDrawer ? 10 : isCardsView ? 13 : 8, mb: 4, ml: open ? 30 : closeAppBarAndDrawer ? 0 : 10, transition: "margin 0.3s" }}
            disableGutters={isGridDetails ? true : false}
          >
            {isCardsView ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {closeAppBarAndDrawer ? (
                  <a
                    href="/"
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      marginTop: "15px",
                      marginRight: "25px",
                    }}
                  >
                    <img
                      src="/everlink-logo.png"
                      alt="logo"
                      style={{ width: "200px", height: "auto" }}
                    />
                  </a>
                ) : <></>}

                {closeAppBarAndDrawer ? (
                  <IconButton
                    aria-label="full-screen"
                    size="large"
                    onClick={handleCloseAppBarAndDrawer}
                    style={{ color: "white", marginTop: "-20px" }}
                  >
                    <FullscreenExitIcon fontSize={'large'} />
                  </IconButton>
                ) : (
                  <IconButton
                    aria-label="full-screen"
                    size="large"
                    onClick={handleCloseAppBarAndDrawer}
                    style={{ color: "white", marginTop: "-20px" }}
                  >
                    <FullscreenRoundedIcon fontSize={'large'} />
                  </IconButton>
                )}
              </Box>
            ) : (
              <></>
            )}

            <div
              className={
                isFota
                  ? styles.pagesContainer
                  : isGridDetails
                    ? styles.pagesGridContainer
                    : isCardsView
                      ? styles.pagesCardsViewContainer
                      : styles.pagesMainContainer
              }
            >
              {breadcrumbs.length > 0 ? (
                <div className={styles.breadcrumbs}>
                  <Breadcrumb breadcrumbs={breadcrumbs} />
                </div>
              ) : (
                <></>
              )}
              {children}
            </div>
            <Footer isCardsView={isCardsView} />
          </Container>
        </Box>
      </div>
    </ThemeProvider>
  );
};
